var map = {
	"./bg-sc.jpg": 436,
	"./bg-tc.jpg": 531,
	"./bg.jpg": 437,
	"./display-area.png": 438,
	"./non-diver-btn-sc.png": 532,
	"./non-diver-btn-tc.png": 533,
	"./option-btn-sc.png": 534,
	"./option-btn-tc.png": 535,
	"./slogan-sc.png": 536,
	"./slogan-tc.png": 537,
	"./title-sc.png": 538,
	"./title-tc.png": 539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 443;